import React, { Component } from 'react'
import Slider from '../components/slider/slider'

class HomePage extends Component {

    render() {
        return (
            <React.Fragment>
                <div class="header-slider-container">
                    <header class="cicegini-bul-header">
                        <h1 class="main-header">ODTÜ Kır Çiçekleri</h1>
                    </header>
                    <Slider />
                    <div class="cicegini-bul-container">
                        <button onClick={() => this.props.history.push("select-plant")} class="cicegini-bul-button">Çiçeğini Bul</button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default HomePage



